import { isEmpty } from './isEmpty'

const regexEmail =
  /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i

export function isValidEmail(email: string): boolean {
  if (isEmpty(email)) return false
  return regexEmail.test(email.trim())
}

export function isNotValidEmail(email?: string): email is undefined {
  if (isEmpty(email)) return true
  return !isValidEmail(email)
}

export function requireValidEmail(email?: string): void {
  if (isEmpty(email)) return
  if (isValidEmail(email)) return
  throw new Error(`Invalid email: ${email}`)
}
